// extracted by mini-css-extract-plugin
export default {"NewTenantDialog":"NewTenantDialog_NewTenantDialog__PH0HR"};